<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
      <el-breadcrumb-item>游戏攻略列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="page-content">
      <el-row @keyup.enter.native="loadData(1)">
        <el-input size="small" placeholder="攻略id" v-model="queryField.contentId"/>
        <el-select
            size="small"
            ref="selectGame"
            v-model="game"
            filterable
            remote
            reserve-keyword
            placeholder="游戏名称"
            @change="handleSelect"
            :remote-method="loadGame"
            @visible-change="cancelReadOnly"
        >
          <el-option
              v-for="item in restaurants"
              :key="item.key"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
        <el-select size="small" v-model="queryField.contentType">
          <el-option label="攻略类型" value=""></el-option>
          <el-option label="攻略" value="1"></el-option>
          <el-option label="视频" value="5"></el-option>
        </el-select>
        <el-select size="small" v-model="queryField.status">
          <el-option label="攻略状态" value=""></el-option>
          <el-option label="正常" value="1"></el-option>
          <el-option label="下架" value="2"></el-option>
        </el-select>
        <el-select size="small" v-model="queryField.sortNum">
          <el-option label="是否置顶" value=""></el-option>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="2"></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="loadData(1)">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
        <el-button size="small" type="primary" @click="toAdd">添加攻略</el-button>
      </el-row>
      
      <el-table class="cps-table-data"
                :data="tableData" size="small"
                border
                :height="height"
                style="width: 100%">
        <el-table-column
            prop="content_id"
            label="攻略ID"
            width="60">
        </el-table-column>
        <el-table-column
            prop="game_id"
            label="游戏ID"
            width="60">
        </el-table-column>
        <el-table-column
            prop="game_name"
            label="游戏名称"
            width="140">
        </el-table-column>
        <el-table-column
            label="攻略名称"
            width="150">
          <template v-slot="scope">
            <el-popover
                placement="bottom"
                width="200"
                :content="scope.row.content_name"
                trigger="click">
              <el-button type="text" slot="reference" style="width: 120px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                {{ scope.row.content_name }}
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
            prop="content_type"
            label="攻略类型"
            :formatter="formatContentType"
            width="100">
        </el-table-column>
        <el-table-column
            label="攻略描述"
            width="150">
          <template v-slot="scope">
            <el-popover
                placement="bottom"
                width="200"
                :content="scope.row.content_des"
                trigger="click">
              <el-button type="text" slot="reference" style="width: 120px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                {{ scope.row.content_des }}
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
            label="视频封面"
            width="120">
          <template v-slot="scope">
            <el-image
                v-if="scope.row.img_url"
                style="width: 40px; height: 40px"
                :src="scope.row.img_url"
                :preview-src-list="[scope.row.img_url]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
            label="视频"
            width="120">
          <template v-slot="scope">
            <el-link v-if="scope.row.video_url" :href="scope.row.video_url" target="_blank">查看视频</el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="status"
            label="视频状态"
            :formatter="formatterVideoStatus"
            width="120">
        </el-table-column>
        <el-table-column
            prop="add_time"
            label="添加时间"
            width="140">
        </el-table-column>
        <el-table-column
            label="操作">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="toEdit(scope.row.content_id)">编辑</el-button>
            <el-button type="text" size="small" @click="toCheckComment(scope.row.content_id)">查看评论</el-button>
            <el-button type="text" size="small" @click="toTopContent(scope.row.content_id)">置顶</el-button>
            <el-button type="text" size="small" @click="cancelTopContent(scope.row.content_id)" v-if="scope.row.sort_num !== 0">取消置顶</el-button>
            <el-button v-if="scope.row.content_type === 5" type="text" size="small" @click="toUpload(scope.row.content_id,scope.row.game_id)">视频上传</el-button>
            <el-button v-if="scope.row.content_type === 5" type="text" size="small" @click="toUploadIMG(scope.row.content_id,scope.row.game_id)">视频图片上传</el-button>
            <!--            <el-button type="text" size="small" @click="deleteById(scope.row.extendId)">删除-->
            <!--            </el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="cps-table-data"
                     @current-change="loadData"
                     background
                     :page-size="pageSize"
                     :current-page="currentIndex"
                     layout="total, prev, pager, next"
                     :total="total">
      </el-pagination>
    </div>
    <el-dialog
        title="视频封面上传"
        :visible.sync="dialogFormVisible"
        :center="true"
        width="400px"
        :show-close="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
    >
      <el-upload
          class="avatar-uploader"
          action=""
          drag
          :data="param"
          :http-request="httpRequestImage"
          :show-file-list="false"
          :before-upload="beforeUploadIcon"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">
          只能上传png/jpg文件，且不超过2M
        </div>
      </el-upload>
    </el-dialog>

    <el-dialog title="视频上传" 
               :visible.sync="dialogFormVisible2" 
               :center=true width="400px" 
               :show-close=true
               :close-on-click-modal=false 
               :close-on-press-escape="false">
      <el-upload
          class="avatar-uploader"
          drag
          action=""
          :data="param"
          :http-request='httpRequest'
          :show-file-list="false"
          :before-upload="beforeUploadVideo">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传mp4文件，且视频比例为16:9不超过5GB</div>
      </el-upload>
      <el-progress ref="appLoadProgress" :percentage="param.progress"></el-progress>
    </el-dialog>

    <el-dialog
        :visible.sync="dialogFormVisible3"
        :close-on-click-modal="false"
        width="30%">
        <el-table :data="commentData"
                  :height="243">
          <el-table-column property="msg" label="评论"></el-table-column>
          <el-table-column label="操作" width="200">
            <template v-slot="scope">
              <el-button type="text" @click="replyMessage(scope.row.msg_id)">回复</el-button>
              <el-button type="text" @click="updateStatus(scope.row.msg_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      <span slot="footer" class="dialog-footer" style="text-align: left">
        <div class="comment-table-data">
          <el-pagination class="cps-table-data"
                         @current-change="loadContentMsg"
                         background
                         :page-size="10"
                         :current-page="commentCurIndex"
                         layout="total, prev, pager, next"
                         :total="commentTotal">
          </el-pagination>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>

import {
  addContentMsg, cancelTopContent,
  loadGame,
  queryContent,
  queryContentMsg, topContent, updateContentMsgStatus,
  uploadContentImage,
  uploadContentVideo
} from "@/api/request";

export default {
  name: 'ContentList',
  data() {
    return {
      tableData: [],
      queryField: {
        contentId: '',
        gameId: '',
        contentType: '',
        status: '',
        sortNum: ''
      },
      total: 0,
      height: window.innerHeight - 210,
      currentIndex: 1,
      pageSize: 15,
      game: '',
      restaurants: [],
      param: {
        gameId: "",
        progress: 0,
        contentId: ""
      },
      dialogFormVisible: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      commentData: [],
      commentTotal: 0,
      commentCurIndex: 1,
      contentId: '',
    };
  },
  mounted() {
    this.loadData(1);
  },
  methods: {
    loadData(index) {
      let params = {
        pageNo: index,
        pageSize: this.pageSize,
        params: this.queryField,
      }
      queryContent(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.currentIndex = index;
      })
    },
    reset(){
      this.queryField = {
        contentId: '',
        gameId: '',
        contentType: '',
        status: ''
      }
      this.game = '';
      this.loadData(1);
    },
    toAdd() {
      this.$router.replace("/content/add")
    },
    toEdit(contentId) {
      this.$router.replace(`/content/edit/${contentId}`)
    },
    toCheckComment(contentId){
      this.dialogFormVisible3 = true;
      this.contentId = contentId;
      this.loadContentMsg(1);
    },
    loadContentMsg(index){
      let params = {
        pageNo: index,
        pageSize: 10,
        params: {
          contentId: this.contentId
        }
      }
      queryContentMsg(params).then(res => {
        this.commentData = res.data.list;
        this.commentTotal = res.data.total;
        this.commentCurIndex = index;
      })
    },
    replyMessage(msgId){
      this.$prompt('回复内容', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        let params = {
          msgId: msgId,
          msg: value
        }
        addContentMsg(params).then(res => {
          if(res.data.success){
            this.$message.success("消息回复成功");
            this.loadContentMsg(this.commentCurIndex);
          }else {
            this.$message.error(res.data.error.message);
          }
        })
      }).catch(() => {
      });
    },
    updateStatus(msgId){
      this.$confirm('确认删除该评论吗？, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateContentMsgStatus(msgId).then(res => {
          if(res.data.success){
            this.$message.success("消息删除成功");
            this.loadContentMsg(this.commentCurIndex);
          }else {
            this.$message.error(res.data.error.message);
          }
        })
      }).catch(() => {
      });
    },
    toTopContent(contentId){
      topContent(contentId).then(res => {
        if (res.data.success) {
          this.$message.success("置顶成功");
          this.loadData(this.currentIndex)
        }else {
          this.$message.error(res.data.error.message);
        }
      })
    },
    cancelTopContent(contentId){
      cancelTopContent(contentId).then(res => {
        if (res.data.success) {
          this.$message.success("取消置顶成功");
          this.loadData(this.currentIndex)
        }else {
          this.$message.error(res.data.error.message);
        }
      })
    },
    toUpload(contentId,gameId){
      this.dialogFormVisible2 = true;
      this.param.contentId = contentId;
      this.param.gameId = gameId;
    },
    toUploadIMG(contentId,gameId){
      this.dialogFormVisible = true;
      this.param.gameId = gameId;
      this.param.contentId = contentId;
    },
    async httpRequestImage(item){
      await uploadContentImage(item).then(res => {
        if(res.success){
          this.dialogFormVisible = false;
          this.$message.success("视频封面上传成功");
        }else {
          this.$message.error(res.error.message);
        }
      });
    },
    async httpRequest(item){
      await uploadContentVideo(item).then(res => {
        if(res.success){
          this.dialogFormVisible2 = false;
          this.$message.success("视频上传成功");
          this.param.progress = 0;
        }else {
          this.$message.error(res.error.message);
        }
      })
    },
    beforeUploadVideo(file) {
      let filename = file.name;
      let pos = filename.lastIndexOf('.');
      let suffix = '';
      if (pos !== -1) suffix = filename.substring(pos);
      this.imgSuffix = suffix;
      //判断文件格式 根据文件格式分流判断
      if (suffix === ".mp4") {
        if (!(file.size / 1024 / 1024 / 1024 < 5)) {
          this.$message.error('上传文件大小不能超过 5GB!');
        }
        else {
          return true
        }
      }
      return false;
    }, 
    beforeUploadIcon(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!(isJPG || isPNG)) {
        this.$message.error("上传头像图片只能是JPG或者PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      let filename = file.name;
      let pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos !== -1) suffix = filename.substring(pos);
      this.imgSuffix = suffix;
      return (isJPG || isPNG) && isLt2M;
    },
    loadGame(query){
      if (query !== '') {
        let me = this;
        loadGame(query).then(res => {
          me.restaurants = [];
          res.data.data.forEach(function (e) {
            let item = {}
            item.key = e.game_id
            item.value = e.game_id
            item.label = e.game_name
            me.restaurants.push(item)
          })
        })
      }
    },
    handleSelect(item){
      this.queryField.gameId = item
    },
    cancelReadOnly(value){
      this.$nextTick(() => {
        if (!value) {
          const {selectGame} = this.$refs;
          const input = selectGame.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          this.$refs.selectGame.blur();
        }
      });
    },
    formatContentType(row, column, cellValue) {
      let ret = ''
      if (cellValue === 1) {
        ret = "攻略"
      } else if(cellValue === 2){
        ret = "活动"
      }else if(cellValue === 3){
        ret = '公告'
      }else if(cellValue === 4){
        ret = '咨询'
      }else if(cellValue === 5){
        ret = '视频'
      }
      return ret;
    },
    formatterVideoStatus(row, column, cellValue){
      let rep = '';
      if(cellValue === 1){
        rep = '正常';
      }else if(cellValue === 2){
        rep = '下架';
      }
      return rep;
    }
  },
  beforeRouteEnter(to,form,next){
    if(form.name === "ContentAdd" || form.name === "ContentEdit"){
      next(vm => {
        vm.loadData(1);
      });
    }else {
      next();
    }
  }
}
</script>
<style scoped>
/deep/ .el-dialog{
  border-radius: 10px;
}

.comment-table-data /deep/ .el-pagination{
  position: unset;
}
</style>

